// extracted by mini-css-extract-plugin
module.exports = {"root":"FetchInitDataWrapper_root__3vgqw"};